import CTA from './CTA';

export { type CTAProps } from './CTA';
export default CTA;
